const ConvertHTMLString = (htmlString) => {
  return htmlString
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&amp;/g, '&')
    .replace(/&quot;/g, '"')
    .replace(/&#039;/g, "'")
    .replace(/&apos;/g, "'")
    .replace(/&nbsp;/g, ' ')
    .replace(/&ndash;/g, '–')
    .replace(/&mdash;/g, '—')
    .replace(/&iexcl;/g, '¡')
    .replace(/&cent;/g, '¢')
    .replace(/&pound;/g, '£')
    .replace(/&curren;/g, '¤')
    .replace(/&yen;/g, '¥')
    .replace(/&brvbar;/g, '¦')
    .replace(/&sect;/g, '§')
    .replace(/&uml;/g, '¨')
    .replace(/&copy;/g, '©')
    .replace(/&ordf;/g, 'ª')
    .replace(/&laquo;/g, '«')
    .replace(/&not;/g, '¬')
    .replace(/&shy;/g, '­')
    .replace(/&reg;/g, '®')
    .replace(/&macr;/g, '¯')
    .replace(/&deg;/g, '°')
    .replace(/&plusmn;/g, '±')
    .replace(/&sup2;/g, '²')
    .replace(/&sup3;/g, '³')
    .replace(/&acute;/g, '´')
    .replace(/&micro;/g, 'µ')
    .replace(/&para;/g, '¶')
    .replace(/&middot;/g, '·')
    .replace(/&cedil;/g, '¸')
    .replace(/&sup1;/g, '¹')
    .replace(/&ordm;/g, 'º')
    .replace(/&raquo;/g, '»')
    .replace(/&frac14;/g, '¼')
    .replace(/&frac12;/g, '½')
    .replace(/&frac34;/g, '¾')
    .replace(/&iquest;/g, '¿')
    .replace(/&times;/g, '×')
    .replace(/&divide;/g, '÷');
};

export default ConvertHTMLString;
